import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityPro2doc } from "../../entity/EntityPro2doc";

export class DtoPro2docsPostReq extends EntityPro2doc {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
